import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { replaceBreakTags } from '../../utils';

const xss = require('xss');

/**
 * @class
 * @name Description
 * @extends Component
 * @param {String} userDescription - the seller's description
 * Container for rendering markup of the seller description
 */

class Description extends Component {

    constructor(props) {
        super(props);
        this.onReadMoreClick = this.onReadMoreClick.bind(this);

        this.state = {
            descExpanded: false
        };
    }

    onReadMoreClick(e) {
        e.preventDefault();

        this.setState({
            descExpanded: !this.state.descExpanded
        });

    }

    render() {

        let desc = '';

        try {
            desc = xss(replaceBreakTags(this.props.userDescription), {
                whiteList: [],
                stripIgnoreTag: true,
                stripIgnoreTagBody: ['script', 'a']
            });
        } catch (error) {
            // fail silently
        }

        const showReadMore = desc.length > 120;

        // if we stripped all tags, the description might now be empty
        if (desc.length > 0) {
            return (
                <article className={`seller-desc ${(this.state.descExpanded || !showReadMore) ? 'expanded' : ''}`}>
                    <h4 className="inner-title">{i18n.t('seller_card.about_me')}</h4>
                    <div className="inner">{desc}</div>
                    {showReadMore &&
                        <a href="#!" className="read-more" onClick={this.onReadMoreClick}>{i18n.t(`seller_card.read_more_text.${this.state.descExpanded ? 'less' : 'more'}`)}</a>
                    }
                </article>
            );
        } else {
            return false;
        }
    }
}

Description.propTypes = {
    userDescription: PropTypes.string
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/description/index.js